<template>
  <div class="my-register-page">
    <div class="my-container">
      <b-row class="mb-2 mt-3 pt-3">
        <b-col>
          <h1>{{ $t("CorruptionReport") }}</h1>
        </b-col>
      </b-row>

      <div class="cr-cards-wrap mt-4">
        <div
          v-for="(type, index) in Types"
          :key="index"
          class="cr-card"
          @click="openReport(type)"
        >
          <div class="cr-card__image">
            <b-img
              src="/images/design/corruption_alert.svg"
              alt="alert"
            />
          </div>
          <div class="cr-card__title">{{ $t(type.label) }}</div>
        </div>
      </div>

      <b-table-simple bordered class="mt-4">
        <b-thead>
          <b-tr variant="primary">
             <b-th style="vertical-align: middle">
              №
            </b-th>
            <b-th style="vertical-align: middle">
              {{ $t("docDate") }}
            </b-th>
            <b-th style="vertical-align: middle">
              {{ $t("type") }}
            </b-th>
            <b-th style="vertical-align: middle">
              {{ $t("inspectionCode") }}
            </b-th>
            <b-th style="text-align: center; vertical-align: middle; width: 80px">
              {{ $t("actions") }}
            </b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="(item, index) in Reports" :key="index">
             <b-td class="text-nowrap">
              {{ index + 1 }}
            </b-td>
            <b-td class="text-nowrap">
              {{ item.docDate }}
            </b-td>
            <b-td>
              {{ item.applicationTypeName || item.applicationType }}
            </b-td>
            <b-td>
              {{ item.inspectionCode }}
            </b-td>
            <b-td style="vertical-align: middle; text-align: center">
              <b-icon-eye-fill
                @click="ViewReport(item)"
                style="cursor: pointer"
              ></b-icon-eye-fill>
            </b-td>
          </b-tr>
          <b-tr v-if="!Reports.length">
            <b-td colspan="5" class="text-center text-muted">
              {{ $t("noData") }}
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <div>
        <b-pagination
          v-model="filter.page"
          :total-rows="filter.totalRows"
          :per-page="filter.pageSize"
          first-number
          last-number
          @input="Refresh"
          class="mb-0 mt-1 mt-sm-0"
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <b-icon icon="chevron-double-left" size="18" />
          </template>
          <template #next-text>
            <b-icon icon="chevron-double-right" size="18" />
          </template>
        </b-pagination>
      </div>

      <b-modal
        v-model="reportModal"
        hide-footer
        hide-header
        no-close-on-backdrop
        size="lg"
      >
        <div
          style="
            text-align: right;
            margin-right: 10px;
            margin-top: -5px;
            margin-bottom: 5px;
            border-bottom: 1px solid lightgray;
          "
        >
          <span
            @click="closeReport()"
            style="cursor: pointer; font-size: 30px"
          >
            &times;
          </span>
        </div>
        <div class="px-2 pb-2">
          <h4 class="mb-3">{{ $t("CorruptionReportTitle") }}</h4>

          <b-row class="mt-2">
            <b-col>
              <custom-input
                :value="selectedType ? $t(selectedType.label) : ''"
                :label="$t('type')"
                :disabled="true"
              />
            </b-col>
          </b-row>

          <b-row class="mt-2" v-if="selectedType && selectedType.code === 'Tekshiruv'">
            <b-col>
              <custom-input
                v-model="form.inspectionCode"
                :label="$t('inspectionCode')"
                :placeholder="$t('inspectionCode')"
              />
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col>
              <custom-textarea
                v-model="form.reportText"
                :rows="5"
                :label="$t('reportText')"
                :placeholder="$t('reportText')"
              />
            </b-col>
          </b-row>

          <b-row class="mt-3">
            <b-col>
              <div class="cr-file-uploader" @click="TriggerFile">
                <input
                  ref="fileInput"
                  type="file"
                  class="cr-file-uploader__input"
                  @change="HandleFileChange"
                />
                <div class="cr-file-uploader__icon">
                  <b-icon icon="paperclip" font-scale="1.4"></b-icon>
                </div>
                <div class="cr-file-uploader__text">
                  <span class="cr-file-uploader__title">
                    {{ $t("attachFile") }}
                  </span>
                </div>
                <b-spinner
                  v-if="fileUploading"
                  small
                  class="ml-auto"
                ></b-spinner>
              </div>
            </b-col>
          </b-row>

          <b-row class="mt-2" v-if="form.files.length">
            <b-col>
              <b-table-simple bordered responsive>
                <b-tbody>
                  <b-tr variant="primary">
                    <b-td style="width: 40px">#</b-td>
                    <b-td>{{ $t("fileName") }}</b-td>
                    <b-td class="text-center" style="width: 80px">
                      {{ $t("actions") }}
                    </b-td>
                  </b-tr>
                  <b-tr
                    v-for="(file, fIndex) in form.files"
                    :key="file.id"
                    style="background-color: white"
                  >
                    <b-td>{{ fIndex + 1 }}</b-td>
                    <b-td>{{ file.name || file.id }}</b-td>
                    <b-td class="text-center">
                      <b-link @click="RemoveFile(fIndex)">
                        <b-icon font-scale="1.2" icon="trash"></b-icon>
                      </b-link>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-col>
          </b-row>

          <b-row class="mt-4">
            <b-col align="left" sm="12" md="6" lg="6">
              <b-button @click="closeReport()" variant="outline-danger">
                {{ $t("cancel") }}
              </b-button>
            </b-col>
            <b-col align="right" sm="12" md="6" lg="6" class="text-right">
              <b-button
                @click="submitReport()"
                variant="outline-success"
                :disabled="Saving"
              >
                <b-spinner v-if="Saving" small></b-spinner>
                {{ $t("send") }}
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-modal>

      <b-modal
        v-model="viewModal"
        hide-footer
        hide-header
        no-close-on-backdrop
        size="lg"
      >
        <div
          style="
            text-align: right;
            margin-right: 10px;
            margin-top: -5px;
            margin-bottom: 5px;
            border-bottom: 1px solid lightgray;
          "
        >
          <span
            @click="closeView()"
            style="cursor: pointer; font-size: 30px"
          >
            &times;
          </span>
        </div>
        <div class="px-2 pb-2">
          <h4 class="mb-3">{{ $t("CorruptionReportTitle") }}</h4>

          <div v-if="viewLoading" class="text-center py-4">
            <b-spinner />
          </div>

          <template v-else-if="viewItem">
            <b-row class="mt-2">
              <b-col cols="12" sm="6">
                <custom-input
                  :value="viewItem.docDate || ''"
                  :label="$t('docDate')"
                  :disabled="true"
                />
              </b-col>
              <b-col cols="12" sm="6">
                <custom-input
                  :value="viewItem.applicationTypeName || viewItem.applicationType || ''"
                  :label="$t('type')"
                  :disabled="true"
                />
              </b-col>
            </b-row>

            <b-row class="mt-2" v-if="viewItem.inspectionCode">
              <b-col>
                <custom-input
                  :value="viewItem.inspectionCode"
                  :label="$t('inspectionCode')"
                  :disabled="true"
                />
              </b-col>
            </b-row>

            <b-row class="mt-2" v-if="viewItem.status">
              <b-col>
                <custom-input
                  :value="viewItem.status"
                  :label="$t('status')"
                  :disabled="true"
                />
              </b-col>
            </b-row>

            <b-row class="mt-2">
              <b-col>
                <custom-textarea
                  :value="viewItem.reportText || ''"
                  :rows="5"
                  :label="$t('reportText')"
                  :disabled="true"
                />
              </b-col>
            </b-row>

            <b-row class="mt-3" v-if="viewItem.files && viewItem.files.length">
              <b-col>
                <h6 class="mb-2">{{ $t("files") }}</h6>
                <b-table-simple bordered responsive>
                  <b-tbody>
                    <b-tr variant="primary">
                      <b-td style="width: 40px">#</b-td>
                      <b-td>{{ $t("fileName") }}</b-td>
                      <b-td class="text-center" style="width: 80px">
                        {{ $t("actions") }}
                      </b-td>
                    </b-tr>
                    <b-tr
                      v-for="(file, fIndex) in viewItem.files"
                      :key="file.id"
                      style="background-color: white"
                    >
                      <b-td>{{ fIndex + 1 }}</b-td>
                      <b-td>
                        <b-link @click="DownloadFile(file)">
                          {{ file.name || file.fileName || file.id }}
                        </b-link>
                      </b-td>
                      <b-td class="text-center">
                        <b-link @click="DownloadFile(file)">
                          <b-icon font-scale="1.2" icon="download"></b-icon>
                        </b-link>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </b-col>
            </b-row>
          </template>

          <b-row class="mt-4">
            <b-col class="text-right">
              <b-button @click="closeView()" variant="outline-danger">
                {{ $t("close") }}
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BButton,
  BImg,
  BModal,
  BSpinner,
  BTableSimple,
  BThead,
  BTbody,
  BTr,
  BTh,
  BTd,
  BPagination,
  BIcon,
  BIconEyeFill,
  BLink,
} from "bootstrap-vue";
import customInput from "../../components/elements/customInput.vue";
import customTextarea from "../../components/elements/customTextarea.vue";
import CorruptionReportService from "@/services/corruptionreport.service";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BImg,
    BModal,
    BSpinner,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
    BPagination,
    BIcon,
    BIconEyeFill,
    BLink,
    customInput,
    customTextarea,
  },
  data() {
    return {
      reportModal: false,
      Saving: false,
      selectedType: null,
      Types: [
        { id: 3, code: "Tekshiruv", label: "Tekshiruv" },
        { id: 2, code: "Muloqot", label: "Muloqot" },
        { id: 1, code: "Profilaktika", label: "Profilaktika" },
      ],
      form: {
        inspectionCode: "",
        reportText: "",
        files: [],
      },
      fileUploading: false,
      Reports: [],
      filter: {
        page: 1,
        pageSize: 20,
        totalRows: 0,
      },
      viewModal: false,
      viewLoading: false,
      viewItem: null,
    };
  },
  created() {
    this.Refresh();
  },
  methods: {
    Refresh() {
      CorruptionReportService.GetList(this.filter)
        .then((res) => {
          this.Reports = res.data.rows || [];
          this.filter.totalRows = res.data.total || 0;
        })
        .catch((error) => {
          this.makeToast(
            (error.response && error.response.data) || error.message,
            "error"
          );
        });
    },
    ViewReport(item) {
      this.viewItem = item;
      this.viewModal = true;
      if (!item || !item.id) return;
      this.viewLoading = true;
      CorruptionReportService.Get(item.id)
        .then((res) => {
          this.viewItem = res.data || item;
          this.viewLoading = false;
        })
        .catch((error) => {
          this.viewLoading = false;
          this.makeToast(
            (error.response && error.response.data) || error.message,
            "error"
          );
        });
    },
    closeView() {
      this.viewModal = false;
      this.viewItem = null;
      this.viewLoading = false;
    },
    generateGuid() {
      if (
        typeof crypto !== "undefined" &&
        typeof crypto.randomUUID === "function"
      ) {
        return crypto.randomUUID();
      }
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    TriggerFile() {
      if (this.fileUploading) return;
      this.$refs.fileInput && this.$refs.fileInput.click();
    },
    HandleFileChange(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) return;
      this.fileUploading = true;
      CorruptionReportService.UploadFile(file)
        .then((res) => {
          let payload = res.data;
          if (Array.isArray(payload)) payload = payload[0];
          const id =
            payload && typeof payload === "object"
              ? payload.id || payload.fileId || payload.Id
              : payload;
          this.form.files.push({ id: id || null, name: file.name });
          this.fileUploading = false;
          if (this.$refs.fileInput) this.$refs.fileInput.value = "";
        })
        .catch((error) => {
          this.fileUploading = false;
          if (this.$refs.fileInput) this.$refs.fileInput.value = "";
          this.makeToast(
            (error.response && error.response.data) || error.message,
            "error"
          );
        });
    },
    RemoveFile(index) {
      const file = this.form.files[index];
      if (!file) return;
      if (!file.id) {
        this.form.files.splice(index, 1);
        return;
      }
      CorruptionReportService.DeleteFile(file.id)
        .then(() => {
          this.form.files.splice(index, 1);
        })
        .catch(() => {
          this.form.files.splice(index, 1);
        });
    },
    DownloadFile(file) {
      if (!file || !file.id) return;
      CorruptionReportService.DownloadFile(file.id)
        .then((res) => {
          const contentType =
            (res.headers && res.headers["content-type"]) ||
            "application/octet-stream";
          const blob =
            res.data instanceof Blob
              ? res.data
              : new Blob([res.data], { type: contentType });

          let filename = file.name || file.fileName || "";
          const disposition =
            res.headers && res.headers["content-disposition"];
          if (disposition) {
            const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
            const asciiMatch = disposition.match(/filename="?([^";]+)"?/i);
            if (utf8Match) {
              filename = decodeURIComponent(utf8Match[1]);
            } else if (asciiMatch) {
              filename = asciiMatch[1];
            }
          }
          if (!filename) filename = file.id;

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          this.makeToast(
            (error.response && error.response.data) || error.message,
            "error"
          );
        });
    },
    openReport(type) {
      this.selectedType = type;
      this.form = { inspectionCode: "", reportText: "", files: [] };
      this.reportModal = true;
    },
    closeReport() {
      this.reportModal = false;
      this.selectedType = null;
      this.form = { inspectionCode: "", reportText: "", files: [] };
    },
    submitReport() {
      if (!this.selectedType) return;
      if (!this.form.reportText || !this.form.reportText.trim()) {
        this.makeToast(this.$t("reportTextRequired"), "error");
        return;
      }

      const userInfo = JSON.parse(localStorage.getItem("user_info") || "{}");
      const payload = {
        docNumber: this.generateGuid(),
        docDate: new Date().toISOString(),
        applicationTypeId: this.selectedType.id,
        reportText: this.form.reportText,
        contractorId: userInfo.contractorId || 0,
        files: this.form.files
          .filter((f) => f.id)
          .map((f) => ({ id: f.id })),
      };
      if (this.selectedType.code === "Tekshiruv") {
        payload.inspectionCode = this.form.inspectionCode;
      }

      this.Saving = true;
      CorruptionReportService.Create(payload)
        .then(() => {
          this.Saving = false;
          this.makeToast(this.$t("SendSuccess"), "success");
          this.closeReport();
          this.Refresh();
        })
        .catch((error) => {
          this.Saving = false;
          this.makeToast(
            (error.response && error.response.data) || error.message,
            "error"
          );
        });
    },
    makeToast(message, type) {
      let a = "";
      if (message && message.status == 500) {
        a = message.title;
      } else if (message && message.status == 400 && message.errors) {
        const errors = Object.values(message.errors);
        a = errors.map((el, i) => i + 1 + "." + el).join("\n");
      } else {
        a = message;
      }
      this.$toast.open({
        message: a,
        type: type,
        duration: 5000,
        dismissible: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.cr-cards-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 24px;
}

.cr-card {
  width: 220px;
  background: #F7F7F7;
  border-radius: 20px;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 22px rgba(63, 117, 254, 0.18);
    background: #fff;
  }

  &__image {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 14px;

    img {
      width: 72px;
      height: 72px;
      object-fit: contain;
    }
  }

  &__title {
    font-size: 16px;
    font-weight: 600;
    color: #1F2937;
    text-align: center;
  }
}

.cr-file-uploader {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 18px;
  background-color: #f7f7f7;
  border: 1.5px dashed #c8d2e5;
  border-radius: 12px;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease;

  &:hover {
    border-color: #3f75fe;
    background-color: #eef3ff;
  }

  &__input {
    display: none;
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-color: #e7eeff;
    color: #3f75fe;
  }

  &__title {
    font-weight: 600;
    color: #293958;
    font-size: 14px;
  }
}

@media screen and (max-width: 576px) {
  .cr-card {
    width: 100%;
    max-width: 320px;
  }
}
</style>
